// 递归
function arrayToNode1 (idx, nodesArray, pid) {
  // const vm = this
  return nodesArray.filter(value => {
    if (idx === 0) {
      if (value.upid === 0 && value.orgid === pid) {
        const arrayToNode = arrayToNode1(1, nodesArray, value.id)
        if (arrayToNode.length > 0) {
          value.child = arrayToNode
        }
        return value
      }
    } else {
      if (value.upid === pid) {
        const arrayToNode = arrayToNode1(1, nodesArray, value.id)
        if (arrayToNode.length > 0) {
          value.child = arrayToNode
        }
        return value
      }
    }
  })
}
export default {
  getapi () {
    let aaa = window.location.protocol + '//' + window.location.host + '/api/v1/web/'
    let aa = window.location.host
    let arr = aa.split(':')
    if (arr[0] === 'localhost' || arr[0] === '10.0.0.8') {
      return 'https://jiaold.com/api/v1/web/'
    } else {
      return aaa
    }
  },
  // 天气图标
  weatherIcon (type) {
    if (type === '晴') {
      return 'static/weatherIcon/qing.png'
    } else if (type === '少云' || type === '晴间多云' || type === '多云') {
      return 'static/weatherIcon/duoyun.png'
    } else if (type === '阴') {
      return 'static/weatherIcon/yin.png'
    } else if (type === '有风' || type === '平静' || type === '微风' || type === '和风' || type === '清风') {
      return 'static/weatherIcon/xiaofeng.png'
    } else if (type === '强风/劲风' || type === '疾风' || type === '大风') {
      return 'static/weatherIcon/zhongfeng.png'
    } else if (type === '烈风' || type === '风暴' || type === '狂爆风' || type === '飓风' || type === '热带风暴') {
      return 'static/weatherIcon/dafeng.png'
    } else if (type === '霾' || type === '中度霾') {
      return 'static/weatherIcon/mai.png'
    } else if (type === '重度霾') {
      return 'static/weatherIcon/zhongmai.png'
    } else if (type === '严重霾') {
      return 'static/weatherIcon/zhongdamai.png'
    } else if (type === '阵雨' || type === '强阵雨') {
      return 'static/weatherIcon/zhenyu.png'
    } else if (type === '雷阵雨' || type === '强雷阵雨') {
      return 'static/weatherIcon/leizhenyu.png'
    } else if (type === '雷阵雨并伴有冰雹') {
      return 'static/weatherIcon/leizhenyubanbingbao.png'
    } else if (type === '小雨' || type === '毛毛雨/细雨' || type === '雨') {
      return 'static/weatherIcon/xiaoyu.png'
    } else if (type === '中雨') {
      return 'static/weatherIcon/zhongyu.png'
    } else if (type === '小雨-中雨') {
      return 'static/weatherIcon/xiaoyu-zhongyu.png'
    } else if (type === '大雨') {
      return 'static/weatherIcon/dayu.png'
    } else if (type === '中雨-大雨') {
      return 'static/weatherIcon/zhongyu-dayu.png'
    } else if (type === '暴雨') {
      return 'static/weatherIcon/baoyu.png'
    } else if (type === '大雨-暴雨') {
      return 'static/weatherIcon/dayu-baoyu.png'
    } else if (type === '大暴雨') {
      return 'static/weatherIcon/dabaoyu.png'
    } else if (type === '暴雨-大暴雨') {
      return 'static/weatherIcon/baoyu-dabaoyu.png'
    } else if (type === '特大暴雨' || type === '极端降雨') {
      return 'static/weatherIcon/tedabaoyu.png'
    } else if (type === '大暴雨-特大暴雨') {
      return 'static/weatherIcon/dabaoyu-teda.png'
    } else if (type === '雨雪天气' || type === '雨夹雪' || type === '阵雨夹雪') {
      return 'static/weatherIcon/yujiaxue.png'
    } else if (type === '冻雨') {
      return 'static/weatherIcon/dongyu.png'
    } else if (type === '雪' || type === '小雪') {
      return 'static/weatherIcon/xiaoxue.png'
    } else if (type === '阵雪') {
      return 'static/weatherIcon/zhenxue.png'
    } else if (type === '中雪') {
      return 'static/weatherIcon/zhongxue.png'
    } else if (type === '大雪') {
      return 'static/weatherIcon/daxue.png'
    } else if (type === '暴雪') {
      return 'static/weatherIcon/baoxue.png'
    } else if (type === '小雪-中雪') {
      return 'static/weatherIcon/xiaoxue-zhongxue.png'
    } else if (type === '中雪-大雪') {
      return 'static/weatherIcon/zhongxue-daxue.png'
    } else if (type === '大雪-暴雪') {
      return 'static/weatherIcon/daxue-baoxue.png'
    } else if (type === '浮尘') {
      return 'static/weatherIcon/fuchen.png'
    } else if (type === '扬沙') {
      return 'static/weatherIcon/yangsha.png'
    } else if (type === '沙尘暴') {
      return 'static/weatherIcon/shachen.png'
    } else if (type === '强沙尘暴') {
      return 'static/weatherIcon/qiangshachen.png'
    } else if (type === '龙卷风') {
      return 'static/weatherIcon/longjuanfeng.png'
    } else if (type === '雾' || type === '浓雾' || type === '强浓雾' || type === '轻雾' || type === '大雾' || type === '特强浓雾  ') {
      return 'static/weatherIcon/wu.png'
    } else if (type === '热') {
      return 'static/weatherIcon/re.png'
    } else if (type === '冷') {
      return 'static/weatherIcon/leng.png'
    } else {
      return 'static/weatherIcon/weizhi.png'
    }
  },
  // 日志类型
  getLogType (type) {
    if (type === 0) {
      // return 'LogTypeLogin'
      return '登录'
    } else if (type === 1) {
      // return 'LogTypeLogout'
      return '登出'
    } else if (type === 10) {
      // return 'LogTypeAddOrg'
      return '新增组织'
    } else if (type === 11) {
      // return 'LogTypeChangeOrg'
      return '修改组织'
    } else if (type === 12) {
      // return 'LogTypeDelOrg'
      return '删除组织'
    } else if (type === 15) {
      // return 'LogTypeAddOrgPerson'
      return '新增平台人员'
    } else if (type === 16) {
      // return 'LogTypeChangeOrgPerson'
      return '修改平台人员'
    } else if (type === 17) {
      // return 'LogTypeDelOrgPerson'
      return '删除平台人员'
    } else if (type === 20) {
      // return 'LogTypeAddUser'
      return '新增登录账号'
    } else if (type === 21) {
      // return 'LogTypeChangeUserRole'
      return '修改登录账号权限'
    } else if (type === 22) {
      // return 'LogTypeChangeUserPassword'
      return '修改登录账号密码'
    } else if (type === 23) {
      // return 'LogTypeReplaceUserPassword'
      return '修改登录账号密码'
    } else if (type === 24) {
      // return 'LogTypeDelUser'
      return '删除登录账号'
    } else if (type === 30) {
      // return 'LogTypeAddHome'
      return '新增家庭'
    } else if (type === 31) {
      // return 'LogTypeChangeHome'
      return '修改家庭'
    } else if (type === 32) {
      // return 'LogTypeDelHome'
      return '删除家庭'
    } else if (type === 35) {
      // return 'LogTypeAddOldPerson'
      return '新增服务对象'
    } else if (type === 36) {
      // return 'LogTypeChangeOldPerson'
      return '修改服务对象'
    } else if (type === 37) {
      // return 'LogTypeDelOldPerson'
      return '删除服务对象'
    } else if (type === 40) {
      // return 'LogTypeAddFamilyPerson'
      return '新增家庭成员'
    } else if (type === 41) {
      // return 'LogTypeChangeFamilyPerson'
      return '修改家庭成员'
    } else if (type === 42) {
      // return 'LogTypeDelFamilyPerson'
      return '删除家庭成员'
    } else if (type === 43) {
      // return 'LogTypeChangeHomeDevice'
      return '修改家庭设备'
    } else if (type === 44) {
      // return 'LogTypeChangePersonDevice '
      return '更新人员设备信息'
    } else if (type === 45) {
      // return 'LogTypeAddHomeDevice'
      return '新增家庭设备'
    } else if (type === 46) {
      // return 'LogTypeAddPersonDevice'
      return '新增设备成员'
    } else if (type === 47) {
      // return 'LogTypeDelHomeDevice '
      return '删除家庭设备'
    } else if (type === 48) {
      // return 'LogTypeDelPersonDevice'
      return '人员设备解绑'
    } else if (type === 49) {
      return '更换设备'
    } else if (type === 50) {
      // return 'LogTypeAddSupplierOrg'
      return '新增服务商'
    } else if (type === 51) {
      // return 'LogTypeChangeSupplierOrg'
      return '修改服务商'
    } else if (type === 52) {
      // return 'LogTypeDelSupplierOrg'
      return '删除服务商'
    } else if (type === 55) {
      // return 'LogTypeAddSupplierOrgPerson'
      return '新增服务商人员'
    } else if (type === 56) {
      // return 'LogTypeChangeSupplierOrgPerson'
      return '修改服务商人员'
    } else if (type === 57) {
      // return 'LogTypeDelSupplierOrgPerson'
      return '删除服务商人员'
    } else if (type === 60) {
      // return 'LogTypeAddSupplierType'
      return '新增服务类型'
    } else if (type === 61) {
      // return 'LogTypeChangeSupplierType'
      return '修改服务类型'
    } else if (type === 62) {
      // return 'LogTypeDelSupplierType'
      return '删除服务类型'
    } else if (type === 65) {
      // return 'LogTypeHandleAlarm'
      return '处理警报'
    } else if (type === 66) {
      // return 'LogTypeSipPhoneCall'
      return '客服拨打电话'
    } else if (type === 70) {
      // return 'LogTypeAddCommunity'
      return '新增小区/机构'
    } else if (type === 71) {
      // return 'LogTypeChangeCommunity'
      return '修改小区/机构'
    } else if (type === 72) {
      // return 'LogTypeDelCommunity'
      return '删除小区/机构'
    } else if (type === 75) {
      // return 'LogTypeAddSIP'
      return '新增SIP电话'
    } else if (type === 76) {
      // return 'LogTypeChangeSIP'
      return '修改SIP电话'
    } else if (type === 77) {
      // return 'LogTypeDelSIP'
      return '删除SIP电话'
    } else if (type === 80) {
      // return 'LogTypeAddSubDevice'
      return '新增子机'
    } else if (type === 81) {
      // return 'LogTypeChangeSubDevice'
      return '修改子机'
    } else if (type === 82) {
      // return 'LogTypeDelSubDevice'
      return '删除子机'
    } else if (type === 85) {
      // return 'LogTypeAddVoiceMessage'
      return '新增FM频率'
    } else if (type === 90) {
      // return 'LogTypeAddGatewayDevicePhonelist'
      return '添加设备号码'
    } else if (type === 91) {
      // return 'LogTypeChangeGatewayDevicePhonelist'
      return '修改设备号码'
    } else if (type === 92) {
      // return 'LogTypeDelGatewayDevicePhonelist'
      return '删除设备号码'
    } else {
      return type
    }
  },
  // 报警类型
  getAlarmType (type) {
    let aa = type
    let atype = type
    if (aa.indexOf('lowvoltage') > -1) {
      return '电量低'
    }
    if (aa.indexOf(',') > -1) {
      atype = aa.split(',')[0]
    }
    if (atype === 'nb-co-test') {
      return 'NB一氧化碳测试'
    } else if (atype === 'nb-co') {
      return 'NB一氧化碳报警'
    } else if (atype === 'F-Test') {
      return '烟感自检报警'
    } else if (atype === 'F-Fire') {
      return '烟感火警'
    } else if (atype === 'F-LB') {
      // 运营看板 报警趋势 忽略F-LB 至 C-AT
      return '烟感低电压报警'
    } else if (atype === 'F-Sensor') {
      return '烟感传感器报警'
    } else if (atype === 'F-Maze') {
      return '烟感迷宫脏'
    } else if (atype === 'C-LB') {
      return '底座低电压报警'
    } else if (atype === 'C-link') {
      return '底座与烟感连接异常报警'
    } else if (atype === 'C-AT') {
      return '底座防拆报警'
      // 以上忽略
    } else if (atype === 'sub_fire') {
      return '烟感'
    } else if (atype === 'sub_co') {
      return '一氧化碳'
    } else if (atype === 'sub_gas') {
      return '燃气'
    } else if (atype === 'sub_keysos') {
      return '按钮报警（紧急报警）'
    } else if (atype === 'sub_infrared') {
      return '红外防盗'
    } else if (atype === 'sub_water') {
      return '水浸'
    } else if (atype === 'sub_opendoor') {
      return '门磁'
    } else if (atype === 'sos' || atype === 'sos-test') {
      return '一键求助'
    } else if (atype === 'sub_lowvoltage') { // 运营看板 报警趋势 忽略
      return '子机低电量'
    } else if (atype === 'sub_test') {
      return '烟感测试'
    } else if (atype === 'sub_lowhumidity') {
      return '湿度低'
    } else if (atype === 'sub_highhumidity') {
      return '湿度高'
    } else if (atype === 'sub_lowtemp') {
      return '温度低'
    } else if (atype === 'sub_hightemp') {
      return '温度高'
    } else if (atype === 'sub_lowlevel') {
      return '水位低'
    } else if (atype === 'sub_highlevel') {
      return '水位高'
    } else if (atype === 'sub_lowpressure') {
      return '水压低'
    } else if (atype === 'sub_highpressure') {
      return '水压高'
    } else if (atype === 'remove') {
      return '摘除'
    } else if (atype === 'outage') {
      return '关机'
    } else if (atype === 'lowpower') {
      return '电量低'
    } else if (atype === 'falldown' || atype === 'fall') {
      return '跌倒'
    } else if (atype === 'heartrate') {
      return '心率警报'
    } else if (atype === 'nonetwork24') {
      return '离线[24]'
    } else if (atype === 'phonein') {
      return '电话呼入'
    } else if (atype === 'birthday') {
      return '生日'
    } else if (atype === 'sub_fire_test') {
      return '子机烟感测试'
    } else if (atype === 'heartbeat') {
      return '心率警报'
    } else if (atype === 'lowbattery') {
      return '低电量'
    } else if (atype === 'sos2') {
      return '服务报警'
    } else if (atype === 'c-at') {
      return '防拆'
    } else if (atype === 'doorclose' || atype === 'door-close') {
      return '关门'
    } else if (atype === 'dooropen' || atype === 'door-open') {
      return '开门'
    } else if (atype === 'sub_heartbeat') {
      return '子机心跳'
    } else if (atype === 'sub_door_open') {
      return '开门'
    } else if (atype === 'sub_door_close') {
      return '关门'
    } else if (atype === 'isactivity') {
      return '无活动报警'
    } else if (atype === 'phoneout') {
      return '外勤'
    } else if (atype === 'no_active_alarm') {
      return '无活动报警'
    } else if (atype === 'stranded_alarm') {
      return '滞留报警'
    } else if (atype === 'human_exist') {
      return '有人'
    } else if (atype === 'human_not_exist') {
      return '无人'
    } else if (atype === 'sub_keysos') {
      return '子机按钮报警'
    } else if (atype === 'sub_keysos_alarm') {
      return '紧急按钮报警'
    } else if (atype === 'sub_keysos_test') {
      return '紧急按钮测试'
    } else if (atype === 'water') {
      return '水浸报警'
    } else if (atype === 'vibration') {
      return '振动'
    } else if (atype === 'achightemp') {
      return '温度报警'
    } else if (atype === 'battery-low' || atype === 'sub_fire,sublowvoltage' || atype === 'sub_fire,sub_lowvoltage' || atype === 'sub_fire test,sub_lowvoltage') {
      return ' 电量低'
    } else if (atype === 'temperature-high') {
      return '温度高'
    } else if (atype === 'temperature-low') {
      return '温度低'
    } else if (atype === 'humidity-high') {
      return '湿度高'
    } else if (atype === 'humidity-low') {
      return '湿度低'
    } else if (atype === 'residence_alarm') {
      return '滞留'
    } else if (atype === 'sleepout') {
      return '离床'
    } else if (atype === 'circle_out_alarm') {
      return '禁止离开围栏'
    } else if (atype === 'circle_in_alarm') {
      return '禁止进入围栏'
    } else if (atype === 'breath-fast') {
      return '呼吸过速'
    } else if (atype === 'breath-slow') {
      return '呼吸过缓'
    } else if (atype === 'alarm-flooding') {
      return '水浸报警'
    } else if (atype === 'alarm-smoke') {
      return '烟雾报警'
    } else if (atype === 'alarm-gas') {
      return '可燃气体报警'
    } else if (atype === 'alarm-button-sos') {
      return '紧急按钮报警'
    } else if (atype === 'alarm-button-test') {
      return '按钮测试'
    } else if (atype === 'alarm-door-open') {
      return '门打开'
    } else if (atype === 'alarm-bell') {
      return '门铃'
    } else if (atype === 'alarm-infrared') {
      return '红外报警'
    } else if (atype === 'alarm-door-close') {
      return '门关闭'
    } else if (atype === 'alarm-human-exist') {
      return '人员存在'
    } else if (atype === 'alarm-human-not-exist') {
      return '人员离开'
    } else if (atype === 'alarm-smoke-test') {
      return '烟雾测试'
    } else if (atype === 'alarm-co') {
      return '一氧化碳报警'
    } else if (atype === 'not-wear') {
      return '未佩戴报警'
    } else if (atype === 'test') {
      return '测试报警'
    } else if (atype === 'no_activity_alarm') {
      return '无活动警报'
    } else {
      return aa
    }
  },
  getAlarmTypeIcon (atype) {
    if (atype === 'nb-co-test' || atype === 'nb-co' || atype === 'sub_co') { // NB一氧化碳测试 NB一氧化碳报警 一氧化碳
      return 1
    } else if (atype === 'F-Test' || atype === 'F-Fire' || atype === 'F-Sensor' ||
      atype === 'F-Maze' || atype === 'sub_fire' || atype === 'sub_fire_test' || atype === 'sub_test') {
      // 烟感自检报警 烟感火警 烟感传感器报警 烟感迷宫脏 烟感 子机烟感测试 烟感测试
      return 2
    } else if (atype === 'F-LB' || atype === 'C-LB') { // 烟感低电压报警 底座低电压报警
      return 3
    } else if (atype === 'C-link' || atype === 'C-AT') { // 底座与烟感连接异常报警 底座防拆报警
      return 4
    } else if (atype === 'sub_gas') { // 燃气
      return 5
    } else if (atype === 'sub_keysos') { // 按钮报警（紧急报警）
      return 6
    } else if (atype === 'sub_infrared') { // 红外防盗
      return 7
    } else if (atype === 'sub_water' || atype === 'water') { // 水浸
      return 8
    } else if (atype === 'sub_opendoor') { // 门磁
      return 9
    } else if (atype === 'sos' || atype === 'sos-test') { // 一键求助
      return 10
    } else if (atype === 'sub_lowvoltage' || atype === 'lowpower') { // 子机低电量 电量低
      return 11
    } else if (atype === 'sub_lowtemp' || atype === 'sub_hightemp') { // 温度低 温度高
      return 12
    } else if (atype === 'sub_lowhumidity' || atype === 'sub_highhumidity') { // 湿度低 湿度高
      return 13
    } else if (atype === 'sub_lowlevel' || atype === 'sub_highlevel') { // 水位低 水位高
      return 14
    } else if (atype === 'sub_lowpressure' || atype === 'sub_highpressure') { // 水压低 水压高
      return 15
    } else if (atype === 'remove') { // 摘除
      return 16
    } else if (atype === 'outage') { // 关机
      return 17
    } else if (atype === 'falldown' || atype === 'fall') { // 跌倒
      return 18
    } else if (atype === 'heartrate' || atype === 'sub_heartbeat') { // 心率警报
      return 19
    } else if (atype === 'phonein') { // 电话呼入
      return 20
    } else if (atype === 'birthday') { // 生日
      return 21
    } else if (atype === 'nonetwork24') { // 离线[24]
      return 22
    } else if (atype === 'heartbeat') { // 心率警报
      return 19
    } else if (atype === 'dooropen' || atype === 'sub_door_open') { // 开门
      return 23
    } else if (atype === 'doorclose' || atype === 'sub_door_close') { // 关门
      return 24
    } else {
      return 0
    }
  },
  // 定位设备
  getMapDevice (devicetype) {
    let arr = [300, 350, 351, 352, 353, 901, 903, 310, 311, 312, 313, 330, 331]
    let flag = false
    if (arr.indexOf(devicetype) > -1) {
      flag = true
    }
    return flag
  },
  // 绑定人
  getWatchDtype () {
    let dtypes = [300, 901, 350, 310, 311, 312, 313, 351, 352, 353, 750, 330, 331]
    return dtypes
  },
  // 701子机设备
  getSubDevice701 () {
    let arr = [
      {model: 'ASK-FLOODING', name: '水浸传感器', icon: 'static/subDevice/son_water.png'},
      {model: 'ASK-SMOKE', name: '烟雾传感器', icon: 'static/subDevice/son_humidity_smoke.png'},
      {model: 'ASK-GAS', name: '燃气传感器', icon: 'static/subDevice/son_gas.png'},
      {model: 'ASK-BUTTON', name: '紧急按钮', icon: 'static/subDevice/son_sub.png'},
      {model: 'ASK-MC', name: '门磁', icon: 'static/subDevice/son_door.png'},
      {model: 'ASK-BELL', name: '门铃', icon: 'static/subDevice/son_doorbell.png'},
      {model: 'ASK-CO', name: '一氧化碳传感器', icon: 'static/subDevice/son_CO.png'},
      {model: 'ASK-INFRARED', name: '红外传感器', icon: 'static/subDevice/son_red.png'},
      {model: 'FSK-SMOKE', name: '烟雾传感器', icon: 'static/subDevice/son_humidity_smoke.png'},
      {model: 'FSK-MC', name: '门磁', icon: 'static/subDevice/son_door.png'},
      {model: 'FSK-BUTTON', name: '拉绳报警器', icon: 'static/subDevice/son_sos.png'},
      {model: 'FSK-FLOODING', name: '水浸传感器', icon: 'static/subDevice/son_water.png'},
      {model: 'FSK-RADAR', name: '雷达传感器', icon: 'static/subDevice/son_leida.png'}
    ]
    return arr
  },
  // 全部的设备类型
  getDeviceTypeArr () {
    return [700, 300, 901, 902, 903, 504, 506, 507, 508, 509, 510, 511, 601, 602, 612, 613, 850, 851, 852, 904, 905, 350, 405, 406, 407, 310,
      311, 312, 351, 352, 353, 750, 751, 402, 752, 331, 753, 536, 537, 538, 539, 540, 541, 542, 754, 533, 534, 313, 330, 701]
  },
  // 设备类型 （上方getDeviceTypeArr 设备类型 getImgArr.js）
  getDeviceType (dtype) {
    let type = parseInt(dtype)
    if (type === 700) {
      return '家庭数字基座'
    } else if (type === 300) {
      return '手表'
    } else if (type === 901) { // 901 特指 北京 w03
      return '随身通'
    } else if (type === 902) {
      return '4G拉绳报警器'
    } else if (type === 903) {
      return '随身通'
    } else if (type === 504) {
      return '门磁'
    } else if (type === 506) {
      return 'NB烟感'
    } else if (type === 507) {
      return 'NB无线按钮'
    } else if (type === 508) {
      return 'NB门磁'
    } else if (type === 509) {
      return 'NB智能锁'
    } else if (type === 510) {
      return 'NB水浸'
    } else if (type === 511) {
      return 'NB断电报警'
    } else if (type === 601 || type === 602 || type === 612) {
      return 'UWB睡眠仪'
    } else if (type === 613) {
      return '4G UWB睡眠仪'
    } else if (type === 850) {
      return '壁挂信息屏'
    } else if (type === 851) {
      return '床头探视终端'
    } else if (type === 852) {
      return '移动护理终端'
    } else if (type === 904 || type === 905) {
      return '断电报警'
    } else if (type === 350) { // 第三方手表
      return '手表-HX99'
    } else if (type === 405) {
      return 'WIFI雷达'
    } else if (type === 406) { // 60g
      return '睡眠仪'
    } else if (type === 407) {
      return '跌倒雷达'
    } else if (type === 310) {
      return '4G手表-WN'
    } else if (type === 311) {
      return '4G手表-YT'
    } else if (type === 312) {
      return '4G手表-JD'
    } else if (type === 351 || type === 352 || type === 353) {
      return '智慧胸卡'
    } else if (type === 750) {
      return '4G血压计'
    } else if (type === 751) {
      return '4G温湿度'
    } else if (type === 402) {
      return 'Wi-Fi门磁'
    } else if (type === 752) {
      return '存在感应'
    } else if (type === 331) {
      return '博实结4G拉绳'
    } else if (type === 753) {
      return '4G温湿度'
    } else if (type === 536) {
      return '4G烟感'
    } else if (type === 537) {
      return '4G拉绳按钮'
    } else if (type === 538) {
      return '4G门磁'
    } else if (type === 539) {
      return '4G智能锁'
    } else if (type === 540) {
      return '4G水浸'
    } else if (type === 541) {
      return '4G断电报警'
    } else if (type === 542) {
      return '4G烟感'
    } else if (type === 754) {
      return '4G睡眠垫'
    } else if (type === 533) {
      return '灭火器压力表'
    } else if (type === 534) {
      return '门磁'
    } else if (type === 780) {
      return '4G跌倒雷达'
    } else if (type === 313) {
      return '4G手表'
    } else if (type === 330) {
      return '4G手表-BSJ'
    } else if (type === 701) {
      return '拉绳网关'
    } else {
      return '测试'
    }
    // （上方 getDeviceTypeArr 设备类型 getImgArr.js）
  },
  // 子设备类型
  getChildDtpyeArr () {
    let arr = [
      {value: -1, label: '警灯'},
      {value: 1, label: '一氧化碳'},
      {value: 2, label: '烟感'},
      {value: 3, label: '燃气'},
      {value: 4, label: '门磁'},
      {value: 5, label: '门铃'},
      {value: 6, label: '红外'},
      {value: 7, label: '水浸'},
      {value: 8, label: '遥控器'},
      {value: 14, label: '门磁'},
      {value: 51, label: '智能开关'},
      {value: 52, label: '温湿度'},
      {value: 53, label: '智能灯泡'},
      {value: 30, label: '睡眠带'},
      {value: 15, label: '存在感应'},
      {value: 31, label: '血压计'},
      {value: 32, label: '睡眠床垫'},
      {value: 16, label: 'SOS拉绳报警器'}
    ]
    return arr
  },
  getChildDtpye (dtype) {
    let type = parseInt(dtype)
    if (type === -1) {
      return '警灯'
    } else if (type === 1) {
      return '一氧化碳'
    } else if (type === 2) {
      return '烟感'
    } else if (type === 3) {
      return '燃气'
    } else if (type === 4) {
      return '门磁'
    } else if (type === 5) {
      return '门铃'
    } else if (type === 6) {
      return '红外'
    } else if (type === 7) {
      return '水浸'
    } else if (type === 8) {
      return '遥控器'
    } else if (type === 14) {
      return '门磁'
    } else if (type === 51) {
      return '智能开关'
    } else if (type === 52) {
      return '温湿度'
    } else if (type === 53) {
      return '智能灯泡'
    } else if (type === 30) {
      return '睡眠带'
    } else if (type === 15) {
      return '存在感应'
    } else if (type === 31) {
      return '血压计'
    } else if (type === 32) {
      return '睡眠床垫'
    } else if (type === 16) {
      return 'SOS拉绳报警器'
    } else {
      return '测试'
    }
  },
  // 56民族
  getNationName () {
    let arr = [
      // 汉族、满族、蒙古族、回族、藏族、
      // 维吾尔族、苗族、彝族、壮族、布依族、
      // 土家族、哈尼族、哈萨克族、傣族、黎族、
      // 傈僳族、佤族、畲族、高山族、拉祜族、
      // 水族、东乡族、纳西族、景颇族、柯尔克孜族、
      // 土族、达斡尔族、仫佬族、羌族、布朗族、
      // 撒拉族、毛南族、仡佬族、锡伯族、阿昌族、
      // 普米族、朝鲜族、塔吉克族、怒族、乌孜别克族、
      // 俄罗斯族、鄂温克族、德昂族、保安族、裕固族、
      // 京族、塔塔尔族、独龙族、鄂伦春族、赫哲族、
      // 侗族、瑶族、白族、门巴族、珞巴族、基诺族 7
      {value: '汉族'}, {value: '满族'}, {value: '蒙古族'}, {value: '回族'}, {value: '藏族'},
      {value: '维吾尔族'}, {value: '苗族'}, {value: '彝族'}, {value: '壮族'}, {value: '布依族'},
      {value: '土家族'}, {value: '哈尼族'}, {value: '哈萨克族'}, {value: '傣族'}, {value: '黎族'},
      {value: '傈僳族'}, {value: '佤族'}, {value: '畲族'}, {value: '高山族'}, {value: '拉祜族'},
      {value: '水族'}, {value: '东乡族'}, {value: '纳西族'}, {value: '景颇族'}, {value: '柯尔克孜族'},
      {value: '土族'}, {value: '达斡尔族'}, {value: '仫佬族'}, {value: '羌族'}, {value: '布朗族'},
      {value: '撒拉族'}, {value: '毛南族'}, {value: '仡佬族'}, {value: '锡伯族'}, {value: '阿昌族'},
      {value: '普米族'}, {value: '朝鲜族'}, {value: '塔吉克族'}, {value: '怒族'}, {value: '乌孜别克族'},
      {value: '俄罗斯族'}, {value: '鄂温克族'}, {value: '德昂族'}, {value: '保安族'}, {value: '裕固族'},
      {value: '京族'}, {value: '塔塔尔族'}, {value: '独龙族'}, {value: '鄂伦春族'}, {value: '赫哲族'},
      {value: '侗族'}, {value: '瑶族'}, {value: '白族'}, {value: '门巴族'}, {value: '珞巴族'}, {value: '基诺族'}
    ]
    return arr
  },
  // 患病
  getDisease (arr) {
    let diseases = []
    for (let i = 0; i < arr.length; i++) {
      if (diseases.indexOf(arr[i].categoryname) === -1) {
        diseases.push(arr[i].categoryname)
      }
    }
    let diseasesnew = []
    for (let i = 0; i < diseases.length; i++) {
      let obj = {
        disabled: true,
        id: diseases[i],
        name: diseases[i],
        categoryname: diseases[i]
      }
      diseasesnew.push(obj)
    }
    for (let i = 0; i < diseasesnew.length; i++) {
      const child = this.getChilds(diseasesnew[i].categoryname, arr)
      if (child.length !== 0) {
        diseasesnew[i].child = child
      }
    }
    return diseasesnew
  },
  getChilds (categoryname, arr) {
    let child = []
    for (let i = 0; i < arr.length; i++) {
      if (categoryname === arr[i].categoryname) {
        child.push(arr[i])
      }
    }
    return child
  },
  // 时间方法
  GetDateStr (AddDayCount) {
    let dd = new Date()
    dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期 负数为前N天 正数为后N天
    // let date = dd.format('yyyy-MM-dd')
    return dd
  },
  GetNextDate (day, AddDayCount) {
    let dd = new Date(day)
    dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期 负数为前N天 正数为后N天
    // let date = dd.format('yyyy-MM-dd')
    return dd
  },
  // 派单树组织
  getNewPaidan (orgData, supplierorgNew, types, serviceData) {
    let id = 1
    let allArr = []
    let arrLevel1 = []
    let orgids = []
    // console.log('服务商', this.supplierorgNew)
    supplierorgNew.forEach(val => {
      if (orgids.indexOf(val.orgid) === -1) {
        orgids.push(val.orgid)
        orgData.forEach(org => {
          if (org.id === val.orgid) {
            let obj = org
            obj.showId = id
            obj.showName = org.name
            obj.noSelect = true
            arrLevel1.push(obj)
            allArr.push(obj)
            id++
          }
        })
      }
    })
    // console.log('组织', id, arrLevel1)
    let showTypes = []
    types.forEach(type => {
      let obj = type
      obj.showId = id
      obj.showName = type.typename
      obj.noSelect = true
      if (window.location.host === 'newjky.wecare-u.net' || window.location.host === 'newhealth.wecare-u.net' ||
        window.location.host === 'kangnh.com' || window.location.host === 'bengshan.kangnh.com' || window.location.host === 'kangnh.com') { // 上海更换
        obj.noSelect = false
      }
      showTypes.push(obj)
      id++
    })
    // console.log('服务类型', id, showTypes)
    let services = []
    serviceData.forEach(ser => {
      let obj = ser
      obj.showId = id
      let showName = ser.service_name
      for (let i = 0; i < supplierorgNew.length; i++) {
        if (obj.so_id === supplierorgNew[i].id) {
          showName = ser.service_name + '--' + supplierorgNew[i].name
        }
      }
      obj.showName = showName
      obj.upid = ser.st_id
      obj.noSelect = false
      services.push(obj)
      id++
    })
    // console.log('服务内容', id, services)
    let arr = showTypes.concat(services)
    allArr = allArr.concat(arr)
    for (let i = 0; i < arrLevel1.length; i++) {
      const child = arrayToNode1(0, arr, arrLevel1[i].id)
      if (child.length !== 0) {
        arrLevel1[i].child = child
      }
    }
    // console.log('最终级联99', arrLevel1)
    let data = {
      allArr,
      tree: arrLevel1
    }
    return data
  },

  // 养老院 老人管理 扩展字段
  getOldPersonForm (oldPersonRow, info) {
    // console.log('form', oldPersonRow, info)
    let form = {
      id: oldPersonRow.id,
      elderly_id: oldPersonRow.elderly_id ? oldPersonRow.elderly_id : '',
      elderly_name: oldPersonRow.elderly_name ? oldPersonRow.elderly_name : '',
      name_pinyin: oldPersonRow.name_pinyin ? oldPersonRow.name_pinyin : '',
      id_type: oldPersonRow.id_type ? oldPersonRow.id_type : '',
      id_number: oldPersonRow.id_number ? oldPersonRow.id_number : '',
      family_code: oldPersonRow.family_code ? oldPersonRow.family_code : '',
      elderly_photo: oldPersonRow.elderly_photo ? oldPersonRow.elderly_photo : '',
      photoid: oldPersonRow.photoid ? oldPersonRow.photoid : null,
      gender: oldPersonRow.gender ? oldPersonRow.gender : '',
      status_code: oldPersonRow.status_code ? oldPersonRow.status_code : '',
      social_security_number: oldPersonRow.social_security_number ? oldPersonRow.social_security_number : ((info && info.social_security_number) ? info.social_security_number : ''),
      birth_date: oldPersonRow.birth_date ? oldPersonRow.birth_date : '',
      zodiac: oldPersonRow.zodiac ? oldPersonRow.zodiac : '',
      nationality: oldPersonRow.nationality ? oldPersonRow.nationality : '',
      place_of_origin: oldPersonRow.place_of_origin ? oldPersonRow.place_of_origin : '',
      marital_status: oldPersonRow.marital_status ? oldPersonRow.marital_status : '',
      educational_level: oldPersonRow.educational_level ? oldPersonRow.educational_level : '',
      religion: oldPersonRow.religion ? oldPersonRow.religion : '',
      pension_income: oldPersonRow.pension_income ? oldPersonRow.pension_income : '',
      contact_phone_number: oldPersonRow.contact_phone_number ? oldPersonRow.contact_phone_number : '',
      mobile_phone_number: oldPersonRow.mobile_phone_number ? oldPersonRow.mobile_phone_number : '',
      residential_district_code: oldPersonRow.residential_district_code ? oldPersonRow.residential_district_code : '',
      residential_address: oldPersonRow.residential_address ? oldPersonRow.residential_address : '',
      residential_postal_code: oldPersonRow.residential_postal_code ? oldPersonRow.residential_postal_code : '',
      household_type: oldPersonRow.household_type ? oldPersonRow.household_type : '',
      household_district_code: oldPersonRow.household_district_code ? oldPersonRow.household_district_code : '',
      household_address: oldPersonRow.household_address ? oldPersonRow.household_address : '',
      household_postal_code: oldPersonRow.household_postal_code ? oldPersonRow.household_postal_code : '',
      has_guardian: oldPersonRow.has_guardian ? oldPersonRow.has_guardian : false,
      'guardian_name': oldPersonRow.guardian_name ? oldPersonRow.guardian_name : '',
      'guardian_gender': oldPersonRow.guardian_gender ? oldPersonRow.guardian_gender : '',
      'guardian_id_type': oldPersonRow.guardian_id_type ? oldPersonRow.guardian_id_type : '',
      'guardian_id_number': oldPersonRow.guardian_id_number ? oldPersonRow.guardian_id_number : '',
      'relationship_with_guardian': oldPersonRow.relationship_with_guardian ? oldPersonRow.relationship_with_guardian : '',
      'guardian_address': oldPersonRow.guardian_address ? oldPersonRow.guardian_address : '',
      'guardian_contact_phone': oldPersonRow.guardian_contact_phone ? oldPersonRow.guardian_contact_phone : '',
      'guardian_mobile_phone': oldPersonRow.guardian_mobile_phone ? oldPersonRow.guardian_mobile_phone : '',
      'guardian_email': oldPersonRow.guardian_email ? oldPersonRow.guardian_email : '',
      'guardian_status': oldPersonRow.guardian_status ? oldPersonRow.guardian_status : '',
      'subsidy_bank': oldPersonRow.subsidy_bank ? oldPersonRow.subsidy_bank : '',
      'subsidy_bank_account': oldPersonRow.subsidy_bank_account ? oldPersonRow.subsidy_bank_account : '',
      'subsidy_bank_account_name': oldPersonRow.subsidy_bank_account_name ? oldPersonRow.subsidy_bank_account_name : '',
      'infectious_disease': oldPersonRow.infectious_disease ? oldPersonRow.infectious_disease : false,
      'mental_illness': oldPersonRow.mental_illness ? oldPersonRow.mental_illness : false,
      'mental_illness_stable': oldPersonRow.mental_illness_stable ? oldPersonRow.mental_illness_stable : '',
      'elderly_alone': oldPersonRow.elderly_alone ? oldPersonRow.elderly_alone : false,
      'live_alone': oldPersonRow.live_alone ? oldPersonRow.live_alone : false,
      'pure_elderly_family': oldPersonRow.pure_elderly_family ? oldPersonRow.pure_elderly_family : false,
      'institutional_elderly': oldPersonRow.institutional_elderly ? oldPersonRow.institutional_elderly : false,
      'home_care_subsidy': oldPersonRow.home_care_subsidy ? oldPersonRow.home_care_subsidy : false,
      'home_care_subsidy_code': oldPersonRow.home_care_subsidy_code ? oldPersonRow.home_care_subsidy_code : '',
      'home_care_subsidy_overlap': oldPersonRow.home_care_subsidy_overlap ? oldPersonRow.home_care_subsidy_overlap : false,
      'home_care_subsidy_overlap_type': oldPersonRow.home_care_subsidy_overlap_type ? oldPersonRow.home_care_subsidy_overlap_type : '',
      'home_care_subsidy_settlement': oldPersonRow.home_care_subsidy_settlement ? oldPersonRow.home_care_subsidy_settlement : '',
      'home_care_subsidy_first_received': oldPersonRow.home_care_subsidy_first_received ? oldPersonRow.home_care_subsidy_first_received : '',
      'home_care_subsidy_total_amount': oldPersonRow.home_care_subsidy_total_amount ? oldPersonRow.home_care_subsidy_total_amount : null,
      'elderly_subsidy': oldPersonRow.elderly_subsidy ? oldPersonRow.elderly_subsidy : false,
      'elderly_subsidy_standard': oldPersonRow.elderly_subsidy_standard ? oldPersonRow.elderly_subsidy_standard : '',
      'elderly_subsidy_settlement': oldPersonRow.elderly_subsidy_settlement ? oldPersonRow.elderly_subsidy_settlement : '',
      'elderly_subsidy_first_received': oldPersonRow.elderly_subsidy_first_received ? oldPersonRow.elderly_subsidy_first_received : '',
      'elderly_subsidy_total_amount': oldPersonRow.elderly_subsidy_total_amount ? oldPersonRow.elderly_subsidy_total_amount : null,
      'institution_elderly_subsidy': oldPersonRow.institution_elderly_subsidy ? oldPersonRow.institution_elderly_subsidy : false,
      'institution_elderly_subsidy_standard': oldPersonRow.institution_elderly_subsidy_standard ? oldPersonRow.institution_elderly_subsidy_standard : '',
      'institution_elderly_subsidy_settlement': oldPersonRow.institution_elderly_subsidy_settlement ? oldPersonRow.institution_elderly_subsidy_settlement : '',
      'institution_elderly_subsidy_first_received': oldPersonRow.institution_elderly_subsidy_first_received ? oldPersonRow.institution_elderly_subsidy_first_received : '',
      'institution_elderly_subsidy_total_amount': oldPersonRow.institution_elderly_subsidy_total_amount ? oldPersonRow.institution_elderly_subsidy_total_amount : null,
      elderly_care_level: oldPersonRow.elderly_care_level ? oldPersonRow.elderly_care_level : '',
      'orgid': oldPersonRow.orgid ? oldPersonRow.orgid : 0,
      'orgmqttlevel': oldPersonRow.orgmqttlevel ? oldPersonRow.orgmqttlevel : '',
      e_id: oldPersonRow.e_id ? oldPersonRow.e_id : 0,
      is_in_out: oldPersonRow.is_in_out ? oldPersonRow.is_in_out : 0,
      // 扩展字段
      extra_info: {},
      // 扩展字段 基本信息
      mate_name: (info && info.mate_name) ? info.mate_name : '',
      married_date: (info && info.married_date) ? info.married_date : '',
      political_status: (info && info.political_status) ? info.political_status : '',
      profession: (info && info.profession) ? info.profession : '',
      career: (info && info.career) ? info.career : '',
      old_person_card: (info && info.old_person_card) ? info.old_person_card : '',
      // 扩展字段 老人病史
      diseaseHistory: {}, // 老人病史 扩展字段
      diseaseHeart: (info && info.diseaseHistory && info.diseaseHistory.diseaseHeart) ? info.diseaseHistory.diseaseHeart : [],
      diseasePressSure: (info && info.diseaseHistory && info.diseaseHistory.diseasePressSure) ? info.diseaseHistory.diseasePressSure : [],
      diseaseBrain: (info && info.diseaseHistory && info.diseaseHistory.diseaseBrain) ? info.diseaseHistory.diseaseBrain : [],
      diseaseFat: (info && info.diseaseHistory && info.diseaseHistory.diseaseFat) ? info.diseaseHistory.diseaseFat : [],
      diseaseBreath: (info && info.diseaseHistory && info.diseaseHistory.diseaseBreath) ? info.diseaseHistory.diseaseBreath : [],
      diseaseAlimentary: (info && info.diseaseHistory && info.diseaseHistory.diseaseAlimentary) ? info.diseaseHistory.diseaseAlimentary : [],
      diseaseMetabolism: (info && info.diseaseHistory && info.diseaseHistory.diseaseMetabolism) ? info.diseaseHistory.diseaseMetabolism : [],
      diseaseBone: (info && info.diseaseHistory && info.diseaseHistory.diseaseBone) ? info.diseaseHistory.diseaseBone : [],
      diseaseSpecial: (info && info.diseaseHistory && info.diseaseHistory.diseaseSpecial) ? info.diseaseHistory.diseaseSpecial : [],
      diseaseHealthy: (info && info.diseaseHistory && info.diseaseHistory.diseaseHealthy) ? info.diseaseHistory.diseaseHealthy : [],
      diseaseSlow: (info && info.diseaseHistory && info.diseaseHistory.diseaseSlow) ? info.diseaseHistory.diseaseSlow : [],
      note: (info && info.diseaseHistory && info.diseaseHistory.note) ? info.diseaseHistory.note : '',
      hospital: (info && info.diseaseHistory && info.diseaseHistory.hospital) ? info.diseaseHistory.hospital : '',
      oftenMedicine: (info && info.diseaseHistory && info.diseaseHistory.oftenMedicine) ? info.diseaseHistory.oftenMedicine : '',
      tabooMedicine: (info && info.diseaseHistory && info.diseaseHistory.tabooMedicine) ? info.diseaseHistory.tabooMedicine : '',
      oldPersonType: (info && info.diseaseHistory && info.diseaseHistory.oldPersonType) ? info.diseaseHistory.oldPersonType : '',
      bloodType: (info && info.diseaseHistory && info.diseaseHistory.bloodType) ? info.diseaseHistory.bloodType : '',
      allergenMedicine: (info && info.diseaseHistory && info.diseaseHistory.allergenMedicine) ? info.diseaseHistory.allergenMedicine : '',
      payment_status_code: (info && info.diseaseHistory && info.diseaseHistory.payment_status_code) ? info.diseaseHistory.payment_status_code : '',
      // 扩展字段 经济情况
      retireUnit: (info && info.retireUnit) ? info.retireUnit : '',
      economicSource: (info && info.economicSource) ? parseInt(info.economicSource) : '',
      annuityGuarantee: (info && info.annuityGuarantee) ? info.annuityGuarantee : '',
      medicalGuarantee: (info && info.medicalGuarantee) ? parseInt(info.medicalGuarantee) : '',
      income: (info && info.income) ? info.income : '',
      // 扩展字段 护理计划
      hygiene: (info && info.hygiene) ? info.hygiene : [],
      service: (info && info.service) ? info.service : [],
      dietMedicine: (info && info.dietMedicine) ? info.dietMedicine : [],
      // 扩展字段 备注信息
      admission_personnel_type: (info && info.admission_personnel_type) ? info.admission_personnel_type : '',
      servicePerson: (info && info.servicePerson) ? info.servicePerson : '',
      serviceDemand: (info && info.serviceDemand) ? info.serviceDemand : '',
      strongPoint: (info && info.strongPoint) ? info.strongPoint : '',
      hobby: (info && info.hobby) ? info.hobby : '',
      isGovernment: (info && info.isGovernment) ? info.isGovernment : '',
      governmentItem: (info && info.governmentItem) ? info.governmentItem : '',
      specialRemark: (info && info.specialRemark) ? info.specialRemark : '',
      // 扩展字段 附件
      sfzPhoto: (info && info.sfzPhoto) ? info.sfzPhoto : [],
      fileArr: (info && info.fileArr) ? info.fileArr : []
    }
    return form
  },
  getJsonInfo (form) {
    // console.log('data', form)
    let info = {
      // 基本信息
      mate_name: form.mate_name ? form.mate_name : '',
      married_date: form.married_date ? form.married_date : '',
      political_status: form.political_status ? form.political_status : '',
      profession: form.profession ? form.profession : '',
      career: form.career ? form.career : '',
      old_person_card: form.old_person_card ? form.old_person_card : '',
      // 老人病史
      diseaseHistory: {
        diseaseHeart: form.diseaseHeart ? form.diseaseHeart : [],
        diseasePressSure: form.diseasePressSure ? form.diseasePressSure : [],
        diseaseBrain: form.diseaseBrain ? form.diseaseBrain : [],
        diseaseFat: form.diseaseFat ? form.diseaseFat : [],
        diseaseBreath: form.diseaseBreath ? form.diseaseBreath : [],
        diseaseAlimentary: form.diseaseAlimentary ? form.diseaseAlimentary : [],
        diseaseMetabolism: form.diseaseMetabolism ? form.diseaseMetabolism : [],
        diseaseBone: form.diseaseBone ? form.diseaseBone : [],
        diseaseSpecial: form.diseaseSpecial ? form.diseaseSpecial : [],
        diseaseHealthy: form.diseaseHealthy ? form.diseaseHealthy : [],
        diseaseSlow: form.diseaseSlow ? form.diseaseSlow : [],
        note: form.note ? form.note : '',
        hospital: form.hospital ? form.hospital : '',
        oftenMedicine: form.oftenMedicine ? form.oftenMedicine : '',
        tabooMedicine: form.tabooMedicine ? form.tabooMedicine : '',
        oldPersonType: form.oldPersonType ? form.oldPersonType : '',
        bloodType: form.bloodType ? form.bloodType : '',
        allergenMedicine: form.allergenMedicine ? form.allergenMedicine : '',
        payment_status_code: form.payment_status_code ? form.payment_status_code : ''
      },
      // 经济情况
      social_security_number: form.social_security_number ? form.social_security_number : '',
      retireUnit: form.retireUnit ? form.retireUnit : '',
      economicSource: form.economicSource ? form.economicSource + '' : '',
      annuityGuarantee: form.annuityGuarantee ? form.annuityGuarantee : '',
      medicalGuarantee: form.medicalGuarantee ? form.medicalGuarantee + '' : '',
      income: form.income ? form.income : '',
      // 护理计划
      hygiene: form.hygiene ? form.hygiene : [],
      service: form.service ? form.service : [],
      dietMedicine: form.dietMedicine ? form.dietMedicine : [],
      // 备注信息
      admission_personnel_type: form.admission_personnel_type ? form.admission_personnel_type : '',
      servicePerson: form.servicePerson ? form.servicePerson : '',
      serviceDemand: form.serviceDemand ? form.serviceDemand : '',
      strongPoint: form.strongPoint ? form.strongPoint : '',
      hobby: form.hobby ? form.hobby : '',
      isGovernment: form.isGovernment ? form.isGovernment : '',
      governmentItem: form.governmentItem ? form.governmentItem : '',
      specialRemark: form.specialRemark ? form.specialRemark : '',
      // 附件
      sfzPhoto: (form && form.sfzPhoto) ? form.sfzPhoto : [],
      fileArr: (form && form.fileArr) ? form.fileArr : []
    }
    let data = {
      id: form.id,
      elderly_id: form.elderly_id ? form.elderly_id : '',
      elderly_name: form.elderly_name ? form.elderly_name : '',
      name_pinyin: form.name_pinyin ? form.name_pinyin : '',
      id_type: form.id_type ? form.id_type : '',
      id_number: form.id_number ? form.id_number : '',
      family_code: form.family_code ? form.family_code : '',
      elderly_photo: form.elderly_photo ? form.elderly_photo : null,
      photoid: form.photoid ? form.photoid : null,
      gender: form.gender ? form.gender : '',
      status_code: form.status_code ? form.status_code : null,
      social_security_number: form.social_security_number ? form.social_security_number : null,
      birth_date: form.birth_date ? form.birth_date : '',
      zodiac: form.zodiac ? form.zodiac : null,
      nationality: form.nationality ? form.nationality : '',
      place_of_origin: form.place_of_origin ? form.place_of_origin : '',
      marital_status: form.marital_status ? form.marital_status : '',
      educational_level: form.educational_level ? form.educational_level : null,
      religion: form.religion ? form.religion : null,
      pension_income: form.pension_income ? form.pension_income : null,
      contact_phone_number: form.contact_phone_number ? form.contact_phone_number : '',
      mobile_phone_number: form.mobile_phone_number ? form.mobile_phone_number : '',
      residential_district_code: form.residential_district_code ? form.residential_district_code : '',
      residential_address: form.residential_address ? form.residential_address : '',
      residential_postal_code: form.residential_postal_code ? form.residential_postal_code : '',
      household_type: form.household_type ? form.household_type : '',
      household_district_code: form.household_district_code ? form.household_district_code : '',
      household_address: form.household_address ? form.household_address : '',
      household_postal_code: form.household_postal_code ? form.household_postal_code : '',
      has_guardian: form.has_guardian ? form.has_guardian : false,
      'guardian_name': form.guardian_name ? form.guardian_name : null,
      'guardian_gender': form.guardian_gender ? form.guardian_gender : null,
      'guardian_id_type': form.guardian_id_type ? form.guardian_id_type : null,
      'guardian_id_number': form.guardian_id_number ? form.guardian_id_number : null,
      'relationship_with_guardian': form.relationship_with_guardian ? form.relationship_with_guardian : null,
      'guardian_address': form.guardian_address ? form.guardian_address : null,
      'guardian_contact_phone': form.guardian_contact_phone ? form.guardian_contact_phone : null,
      'guardian_mobile_phone': form.guardian_mobile_phone ? form.guardian_mobile_phone : null,
      'guardian_email': form.guardian_email ? form.guardian_email : null,
      'guardian_status': form.guardian_status ? form.guardian_status : null,
      'subsidy_bank': form.subsidy_bank ? form.subsidy_bank : null,
      'subsidy_bank_account': form.subsidy_bank_account ? form.subsidy_bank_account : null,
      'subsidy_bank_account_name': form.subsidy_bank_account_name ? form.subsidy_bank_account_name : null,
      'infectious_disease': form.infectious_disease ? form.infectious_disease : false,
      'mental_illness': form.mental_illness ? form.mental_illness : false,
      'mental_illness_stable': form.mental_illness_stable ? form.mental_illness_stable : null,
      'elderly_alone': form.elderly_alone ? form.elderly_alone : false,
      'live_alone': form.live_alone ? form.live_alone : false,
      'pure_elderly_family': form.pure_elderly_family ? form.pure_elderly_family : false,
      'institutional_elderly': form.institutional_elderly ? form.institutional_elderly : false,
      'home_care_subsidy': form.home_care_subsidy ? form.home_care_subsidy : false,
      'home_care_subsidy_code': form.home_care_subsidy_code ? form.home_care_subsidy_code : null,
      'home_care_subsidy_overlap': form.home_care_subsidy_overlap ? form.home_care_subsidy_overlap : false,
      'home_care_subsidy_overlap_type': form.home_care_subsidy_overlap_type ? form.home_care_subsidy_overlap_type : null,
      'home_care_subsidy_settlement': form.home_care_subsidy_settlement ? form.home_care_subsidy_settlement : null,
      'home_care_subsidy_first_received': form.home_care_subsidy_first_received ? form.home_care_subsidy_first_received : null,
      'home_care_subsidy_total_amount': form.home_care_subsidy_total_amount ? form.home_care_subsidy_total_amount : null,
      'elderly_subsidy': form.elderly_subsidy ? form.elderly_subsidy : false,
      'elderly_subsidy_standard': form.elderly_subsidy_standard ? form.elderly_subsidy_standard : null,
      'elderly_subsidy_settlement': form.elderly_subsidy_settlement ? form.elderly_subsidy_settlement : null,
      'elderly_subsidy_first_received': form.elderly_subsidy_first_received ? form.elderly_subsidy_first_received : null,
      'elderly_subsidy_total_amount': form.elderly_subsidy_total_amount ? form.elderly_subsidy_total_amount : null,
      'institution_elderly_subsidy': form.institution_elderly_subsidy ? form.institution_elderly_subsidy : false,
      'institution_elderly_subsidy_standard': form.institution_elderly_subsidy_standard ? form.institution_elderly_subsidy_standard : null,
      'institution_elderly_subsidy_settlement': form.institution_elderly_subsidy_settlement ? form.institution_elderly_subsidy_settlement : null,
      'institution_elderly_subsidy_first_received': form.institution_elderly_subsidy_first_received ? form.institution_elderly_subsidy_first_received : null,
      'institution_elderly_subsidy_total_amount': form.institution_elderly_subsidy_total_amount ? form.institution_elderly_subsidy_total_amount : null,
      elderly_care_level: form.elderly_care_level ? form.elderly_care_level : null,
      'orgid': form.orgid ? form.orgid : 0,
      'orgmqttlevel': form.orgmqttlevel ? form.orgmqttlevel : '',
      e_id: form.e_id ? form.e_id : 0,
      is_in_out: form.is_in_out ? form.is_in_out : 0,
      economicSource: form.economicSource ? form.economicSource + '' : '',
      medicalGuarantee: form.medicalGuarantee ? form.medicalGuarantee + '' : '',
      extra_info: JSON.stringify(info)
    }
    return data
  },

  // 户籍性质
  getHouseholdArr () {
    return [
      {id: '1', name: '本市-本区'},
      {id: '2', name: '本市-外区'},
      {id: '3', name: '外地'},
      {id: '9', name: '其他'}
    ]
  },
  // 政治面貌 缺老人
  getPoliticalArr () {
    return [
      {id: '01', name: '中共党员'},
      {id: '02', name: '中共预备党员'},
      {id: '03', name: '共青团员'},
      {id: '04', name: '民革党员'},
      {id: '05', name: '民盟盟员'},
      {id: '06', name: '民建会员'},
      {id: '07', name: '民进会员'},
      {id: '08', name: '农工党党员'},
      {id: '09', name: '致公党党员'},
      {id: '10', name: '九三学社社员'},
      {id: '11', name: '台盟盟员'},
      {id: '12', name: '无党派人士'},
      {id: '13', name: '群众'}
    ]
  },
  // 文化程度
  getEducationArr () {
    return [
      {id: '1', name: '硕士'},
      {id: '2', name: '本科'},
      {id: '3', name: '专科'},
      {id: '4', name: '高中'},
      {id: '5', name: '初中'},
      {id: '6', name: '小学'},
      {id: '7', name: '社会'}
    ]
  },
  // 照护等级
  getCareLevelArr () {
    return [
      {id: '1', name: '正常'},
      {id: '2', name: '轻度'},
      {id: '3', name: '中度Ⅰ'},
      {id: '4', name: '中度Ⅱ'},
      {id: '5', name: '重度Ⅰ'},
      {id: '6', name: '重度Ⅱ'}
    ]
  },
  // 能力级别
  getAbilityLevel () {
    return [
      {id: '0', name: '能力完好'},
      {id: '1', name: '能力轻度受损(轻度失能)'},
      {id: '2', name: '能力中度受损(中度失能)'},
      {id: '3', name: '能力重度受损(重度失能)'},
      {id: '4', name: '能力完全丧失(完全失能)'}
    ]
  },
  // 老人类别
  getAdmissionPersonnelTypeArr () {
    return [
      {id: 1, name: '五助老人'},
      {id: 2, name: '空巢老人'},
      {id: 3, name: '独居老人'},
      {id: 4, name: '孤寡老人'},
      {id: 5, name: '五保老人'},
      {id: 6, name: '三无老人'},
      {id: 7, name: '机构员工'}
    ]
  },
  // 特长
  getSpecialArr () {
    return [
      {id: 1, name: '唱京剧'},
      {id: 2, name: '兵乓球'},
      {id: 3, name: '斗空竹'},
      {id: 4, name: '打太极'},
      {id: 5, name: '旅游'},
      {id: 6, name: '书法'},
      {id: 7, name: '绘画'}
    ]
  },
  // 老人类型
  getOldPersonTypeArr () {
    return [
      {id: 1, name: '城市三无老人'},
      {id: 2, name: '农村五保老人'},
      {id: 3, name: '低保老人'},
      {id: 4, name: '孤寡老人'},
      {id: 5, name: '养老服务补贴带入机构老人'},
      {id: 6, name: '自费老人'},
      {id: 9, name: '其他'}
    ]
  },
  // 经济来源
  getEconomicArr () {
    return [
      {id: 1, name: '子女补助'},
      {id: 2, name: '政府补助'},
      {id: 3, name: '退休金'}
    ]
  },
  // 养老保障情况
  getAnnuityGuaranteeArr () {
    return [
      {id: 1, name: '低保'},
      {id: 2, name: '养老补金'},
      {id: 3, name: '高龄补贴'}
    ]
  },
  // 医疗保障情况
  getMedicalGuaranteeArr () {
    return [
      {id: 1, name: '新农村合作医疗'},
      {id: 2, name: '城乡居民合作医疗'},
      {id: 3, name: '城镇职工基本医疗'}
    ]
  },
  // 与老人关系
  getRelationShipArr () {
    return [
      {id: 1, name: '父子'},
      {id: 2, name: '父女'},
      {id: 3, name: '兄弟'},
      {id: 4, name: '同事'},
      {id: 5, name: '母子'},
      {id: 6, name: '母女'},
      {id: 7, name: '孙子'},
      {id: 8, name: '孙女'},
      {id: 9, name: '姐妹'},
      {id: 10, name: '夫妻'},
      {id: 11, name: '朋友'},
      {id: 12, name: '亲戚'}
    ]
  },
  // 代管物品状态
  getGoodsStatusArr () {
    return [
      {id: 1, name: '存'},
      {id: 2, name: '取'}
    ]
  },
  // 岗位类型
  getJobCodeArr () {
    return [
      {id: '1', name: '管理骨干'},
      {id: '2', name: '医生'},
      {id: '3', name: '护士'},
      {id: '4', name: '营养师'},
      {id: '5', name: '社工'},
      {id: '6', name: '护工'},
      {id: '7', name: '后勤'},
      {id: '8', name: '食堂'}
    ]
  },
  // 岗位性质
  getJobNatureCodeArr () {
    return [
      {id: '1', name: '全职'},
      {id: '2', name: '兼职'},
      {id: '9', name: '不详'}
    ]
  },
  // 病例
  // 慢性疾病
  getDiseaseSlowArr () {
    return [
      {id: 1, name: '糖尿病'},
      {id: 2, name: '高血压'},
      {id: 3, name: '高血糖'},
      {id: 4, name: '心肌埂塞'}
    ]
  },
  // 心血管疾病
  getDiseaseHeartArr () {
    return [
      {id: 1, name: '心脏病'},
      {id: 2, name: '冠心病'},
      {id: 3, name: '心绞痛'},
      {id: 4, name: '心肌梗死'},
      {id: 5, name: '心律失常'},
      {id: 6, name: '心功能不全'},
      {id: 7, name: '早搏'}
    ]
  },
  // 血压疾病
  getDiseasePressSureArr () {
    return [
      {id: 1, name: '高血压'},
      {id: 2, name: '低血压'},
      {id: 3, name: '原发性高血压'},
      {id: 4, name: '肾性高血压'},
      {id: 5, name: '肾性高血压'}
    ]
  },
  // 脑血管疾病
  getDiseaseBrainArr () {
    return [
      {id: 1, name: '缺血性'},
      {id: 2, name: '出血性'},
      {id: 3, name: '帕金森'},
      {id: 4, name: '脑梗'},
      {id: 5, name: '腔梗'},
      {id: 6, name: '中风'},
      {id: 7, name: '脑溢血'}
    ]
  },
  // 高脂血症
  getDiseaseFatArr () {
    return [
      {id: 1, name: '高血脂'},
      {id: 2, name: '高胆固醇'},
      {id: 3, name: '脂肪肝'},
      {id: 4, name: '混合性高血脂症'}
    ]
  },
  // 慢性呼吸道疾病
  getDiseaseBreathArr () {
    return [
      {id: 1, name: '慢性支气管炎'},
      {id: 2, name: '哮喘性支气管炎'},
      {id: 3, name: '肺气肿'},
      {id: 4, name: '支气管哮喘'},
      {id: 5, name: '肺纤维化'},
      {id: 6, name: '过敏性气管炎'},
      {id: 7, name: '过敏性鼻炎'}
    ]
  },
  // 消化道疾病
  getDiseaseAlimentaryArr () {
    return [
      {id: 1, name: '胃溃疡'},
      {id: 2, name: '十二指肠溃疡'},
      {id: 3, name: '大出血'},
      {id: 4, name: '反流性食管炎'},
      {id: 5, name: '胆石症'},
      {id: 6, name: '胆囊炎'},
      {id: 7, name: '慢性结肠炎'}
    ]
  },
  // 代谢性疾病
  getDiseaseMetabolismArr () {
    return [
      {id: 1, name: '糖尿病'},
      {id: 2, name: '糖尿病Ⅰ型'},
      {id: 3, name: '糖尿病Ⅱ型'},
      {id: 4, name: '糖尿病Ⅲ型'},
      {id: 5, name: '糖尿病特殊型'},
      {id: 6, name: '肾功能不全'}
    ]
  },
  // 骨关节疾病
  getDiseaseBoneArr () {
    return [
      {id: 1, name: '骨质疏松'},
      {id: 2, name: '腰椎间盘病变'},
      {id: 3, name: '肩周炎'},
      {id: 4, name: '风湿性关节炎'},
      {id: 5, name: '类风湿性关节炎'},
      {id: 6, name: '颈椎病'}
    ]
  },
  // 特殊病例
  getDiseaseSpecialArr () {
    return [
      {id: 1, name: '听力衰退'},
      {id: 2, name: '语言障碍'},
      {id: 3, name: '行动不便'},
      {id: 4, name: '思维迟钝'},
      {id: 5, name: '视力模糊'},
      {id: 6, name: '长期卧床'},
      {id: 7, name: '残疾'},
      {id: 8, name: '白内障'},
      {id: 9, name: '失明'},
      {id: 10, name: '失聪'}
    ]
  },
  // 健康档案疾病
  getDiseaseHealthyArr () {
    return [
      {id: 1, name: '高血压'},
      {id: 2, name: '高血压伴慢性肾脏病'},
      {id: 3, name: '糖尿病'},
      {id: 4, name: '癌症'},
      {id: 5, name: '慢阻肺'},
      {id: 6, name: '心脏病（心机梗死、冠心病等）'},
      {id: 7, name: '脑卒中'},
      {id: 8, name: '精神疾病'},
      {id: 9, name: '便秘'},
      {id: 10, name: '慢性肾脏病'},
      {id: 11, name: '高血压伴脑血管病'},
      {id: 12, name: '骨质疏松症'}
    ]
  },
  // 机构类型
  getEntityTypeArr () {
    return [
      {id: '10', name: '行政机构'},
      {id: '20', name: '事业单位'},
      {id: '21', name: '财政补助事业单位'},
      {id: '22', name: '自收自支事业单位'},
      {id: '30', name: '国有企业单位'},
      {id: '31', name: '民营企业单位'},
      {id: '40', name: '外商独资单位'},
      {id: '41', name: '中外合资单位'},
      {id: '42', name: '中外合作单位'},
      {id: '50', name: '民办非企业单位'},
      {id: '51', name: '社会组织'},
      {id: '60', name: '个人'},
      {id: '99', name: '其他'}
    ]
  },
  // 房屋使用形式
  getHouseTypeArr () {
    return [
      {id: '有产证-自有产权', name: '有产证-自有产权'},
      {id: '有产证-使用权', name: '有产证-使用权'},
      {id: '有产证-租赁', name: '有产证-租赁'},
      {id: '无产证-使用权', name: '无产证-使用权'},
      {id: '无产证-租赁', name: '无产证-租赁'},
      {id: '其他', name: '其他'}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/common/commonType.js